export default (state = 0, { type, payload }) => {
  switch (type) {
    case 'SET_TOP_OFFSET':
      return payload
    default:
      return state
  }
}